<template>
  <div class="card-ct card-rounded-shadowed p-4 mb-4">
    <div class="row">
      <div class="col-12">
        <h3 class="mb-3">{{ title }}</h3>
        <div class="blog-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
